<template>
  <div class="d-flex flex-column gap-2">
    <template v-if="hasPreexistingListings">
      <div>
        We found {{ model.preExistingListings.length === 1 ? 'a listing' : `${model.preExistingListings.length} listings`}}
        that may already belong to this property.
      </div>
      <div class="mb-3 list-group">
        <div v-for="listing in model.preExistingListings" :key="listing.id" class="list-group-item d-flex flex-row align-items-center">
          <ListingRegistrationItem :public-view="model.city.isPublicView" :pre-existing-listing="listing" class="flex-grow-1 me-3" />
          <button class="btn btn-icon btn-flat" @click="removeListing(listing)">
            <i class="bi-trash"/>
          </button>
        </div>
      </div>
    </template>
    <div>
      If this property is {{ hasPreexistingListings ? 'listed on any additional ' : 'already listed on any ' }}short-term rental sites, please provide the link(s) below.
    </div>
    <div v-if="model.listings.length > 0" class="list-group">
      <div v-for="listing in model.listings" :key="listing" class="list-group-item d-flex flex-row align-items-center">
        <ListingRegistrationItem :public-view="model.city.isPublicView" :url="listing" :city-id="model.cityId" class="flex-grow-1 me-3" />
        <button class="btn btn-icon btn-flat" @click="removeListing(listing)">
          <i class="bi-trash"/>
        </button>
      </div>
    </div>
    <div>
      <input type="url" class="form-control " placeholder="https://..." v-model="newListing" @keydown.enter.prevent.stop="addNewListing" />
      <div class="form-text">Press Enter to add new listing</div>
    </div>
  </div>
</template>

<script>
import {LicenseEditorModel} from "@/models/LicenseEditorModel";
import ListingRegistrationItem from "@/components/register/ListingRegistrationItem.vue";
import {Listing} from "@/models/Listing";

export default {
  components: {ListingRegistrationItem},
  props: {
    model: LicenseEditorModel
  },
  data() {
    return {
      newListing: ''
    };
  },
  mounted() {
    this.model.propertyId;
  },
  computed: {
    hasPreexistingListings() {
      return this.model.preExistingListings.length > 0;
    },
    listings: {
      get() {
        return this.model.listings.join('\n');
      },
      set(urls) {
        this.model.listings = urls.split(/\n/).map(url => url.trim());
      }
    }
  },
  methods: {
    addNewListing() {
      if (this.newListing) {
        this.model.listings.push(
          this.newListing
          .replace(/(https:\/\/.*\.airbnb\.com\/rooms\/\d+).*/, '$1')
          .replace(/(https:\/\/.*\.vrbo\.com\/[\da-zA-Z]+).*/, '$1')
          .replace(/(https:\/\/.*\.flipkey\.com\/properties\/\d+).*/, '$1')
        );
        this.newListing = '';
      }
    },
    removeListing(listing) {
      if (listing instanceof Listing) {
        this.model.preExistingListings = this.model.preExistingListings.filter(l => l.id !== listing.id);
      } else {
        this.model.listings = this.model.listings.filter(l => l !== listing);
      }
    }
  }
}
</script>
